import { addVariant, addSubscriptionVariant } from '../slater/cart.js'
import { component } from 'picoapp'
import wait from 'w2t'
import serialize from 'form-serialize'
import ScrollMagic from 'scrollmagic'

export default component(({ node: el, state }) => {
  const { selectedOrFirstAvailableVariant, product } = JSON.parse(el.querySelector('.js-product-json').innerHTML)
  let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0]

  const controller = new ScrollMagic.Controller()
  const animateIn = document.querySelectorAll('.js-animate')

  animateIn.forEach((item) => {
    new ScrollMagic.Scene({
      triggerElement: item,
      duration: 400,
      offset: -400
    }).addTo(controller)
    .on('enter', () => {
      item.classList.add('visible')
    })
  })

  const form = el.getElementsByTagName('form')[0]
  const submit = form.querySelector('.js-submit-cart')
  const quantity = form.querySelector('.js-quantity').value

  const imageMain = el.querySelector('.js-image-main')
  const images = el.querySelectorAll('.js-image-update')
  images.forEach(image => {
    image.addEventListener('click', e => {
      e.preventDefault()
      imageMain.src = e.currentTarget.getAttribute('href')
    })
  })

  const ingreds = document.querySelectorAll('.js-ingred')
  if (ingreds) {
    ingreds.forEach((gredient, i) => {
      const [ title ] = gredient.children
      gredient.addEventListener('click', () => {
        const details = gredient.querySelector('.js-details')
        // Toggle the other open ingredients
        ingreds.forEach((single, x) => {
          if (x !== i) {
            const sDetails = single.querySelector('.js-details')
            single.classList.remove('open')
            sDetails.classList.add('inactive')
          }
        })

        gredient.classList.toggle('open')
        details.classList.toggle('inactive')
      })
    })
  }

  const closers = [].slice.call(document.querySelectorAll('.js-modal-close'))
  const modal = document.querySelector('.js-modal')
  const modalOpen = document.querySelector('.js-modal-open')

  const qMove = form.querySelector('.js-quantity')

  qMove.addEventListener('change', () => {
    const cButton = form.querySelector('.js-submit-cart')
    const baseRetail = document.querySelector('.js-baseline')
    const baseRetailPrice = baseRetail.getAttribute('data-retail')
    const cValue = cButton.querySelector('span').getAttribute('data-baseline')
    cButton.querySelector('span').innerHTML = (parseInt(form.querySelector('.js-quantity').value) * parseInt(cValue)).toLocaleString()
    baseRetail.innerHTML = `$${(parseInt(form.querySelector('.js-quantity').value) * parseInt(baseRetailPrice)).toLocaleString()}`
  })

  if (closers && modal) {
    modalOpen.addEventListener('click', () => {
      modal.classList.add('open')
    })
    closers.forEach(close => {
      close.addEventListener('click', () => {
        modal.classList.remove('open')
      })
    })
  }

  form.addEventListener('submit', e => {
    e.preventDefault()
    // submit.children[0].innerHTML = 'Adding..'

    let formSerialized = serialize(form, { hash: true })
    formSerialized.quantity = parseInt(formSerialized.quantity)
    const hiddenForm = document.querySelector('.js-footer-cart')
    hiddenForm.classList.remove('hidden')

    // if (formSerialized.properties) {
    //   let sendData = Object.assign(currentVariant, formSerialized)
    //   wait(1000, [
    //     addSubscriptionVariant(sendData, quantity).then(({ item, cart }) => {
    //       submit.children[0].innerHTML = 'Add to Cart'
    //     }).catch(e => {
    //       alert(e)
    //     })
    //   ])
    // } else {
      wait(1000, [
        addVariant(currentVariant, parseInt(formSerialized.quantity)).then(({ item, cart }) => {
          // submit.children[0].innerHTML = 'Add to Cart'
        }).catch(e => {
          alert(e)
        })
      ])
    // }
    // console.log('hiiiya', serialize(form, { hash: true }))
    // wait(1000, [
    //   addVariant(currentVariant, quantity).then(({ item, cart }) => {
    //     submit.children[0].innerHTML = 'Add to Cart'
    //   }).catch(e => {
    //     alert(e)
    //   })
    // ])
  })
})
